import React, { FC } from 'react';
import FormErrorsPreviewErrorTarget
	from '../../../modules/detailPage/components/FormErrorsPreview/FormErrorsPreviewErrorTarget';
import ControlGroup from '../../ControlGroup';
import { FormFieldAdapterProps } from '../../CustomForm';
import { TextareaWithPreview } from '../../Textarea';
import { TextareaProps } from '../../Textarea/Textarea';
import { ValidationMessage } from '../../ValidationMessage';
import { getDisabledProp } from '../utils';
import { getPreviewModeProp } from '../../CustomForm/adapters/utils/base';

type TextareaAdapterProps = FormFieldAdapterProps<TextareaProps>;

const TextareaAdapter: FC<TextareaAdapterProps> = (props) => {
	const {
		input,
		meta: { invalid, touched, error },
		metadata,
		controlProps,
		componentProps,
		previewProps = {},
	} = props;
	const { value, name, onChange, onFocus, onBlur } = input;
	const showValidation = props.immediateValidation ? invalid : invalid && touched;

	const handleFocus = (e) => {
		componentProps?.onFocus?.(e);

		return onFocus(e);
	};

	const handleBlur = (e) => {
		componentProps?.onBlur?.(e);

		return onBlur(e);
	};

	return (
		<ControlGroup
			{...controlProps}
			valid={!showValidation}
			validationMessage={<ValidationMessage keyCode={error} />}
		>
			<FormErrorsPreviewErrorTarget targetName={name}>
				<TextareaWithPreview
					{...previewProps}
					{...componentProps}
					previewMode={getPreviewModeProp({
						metadataPreviewMode: metadata?.previewMode,
						previewMode: props.previewMode,
					})}
					disabled={getDisabledProp({ metadataDisabled: metadata?.disabled, disabled: props.disabled })}
					name={name}
					value={value}
					onChange={onChange}
					invalid={showValidation}
					onFocus={handleFocus}
					onBlur={handleBlur}
				/>
			</FormErrorsPreviewErrorTarget>
		</ControlGroup>
	);
};

export { TextareaAdapter };
export default TextareaAdapter;
